import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllTask, taskPartGetDataApi } from "../../Api/Task/TaskApi";
import { mapTasks } from "../Types/Task/TaskInterface";

export const getAllTaskData = createAsyncThunk(
    'getAllTaskData',
    async (_, { rejectWithValue }) => {
      try {
        const allTasks = await getAllTask();

        if (allTasks.status) {
          return mapTasks(allTasks.body.data);
        } else {
          // If the API returns a failure status, return the error message
          return rejectWithValue(allTasks.error);
        }
      } catch (error: any) {
        // Handle the case where the API call itself throws an error
        return rejectWithValue('Failed to fetch all Tasks');
      }
    }
  );

